import CreateRequestTypes from '../rootActionType';

export const PROJECT_DETAILS = CreateRequestTypes('PROJECT_DETAILS');
export const PARTICULAR_PRODUCT_DETAILS = CreateRequestTypes(
  'PARTICULAR_PRODUCT_DETAILS'
);
